import React from "react";
var __jsx = React.createElement;
import { FormattedMessage } from 'react-intl';
import { HoverButton } from 'components/common/material-ui/custom-components';
import Style from './ImagePreview.style';

var ImagePreview = function ImagePreview(_ref) {
  var imgUrl = _ref.imgUrl,
      onReplaceButtonClick = _ref.onReplaceButtonClick,
      onCropButtonClick = _ref.onCropButtonClick;
  return __jsx(Style.PreviewContainer, null, __jsx(Style.ImgHover, null, __jsx(Style.HoverButtonContainer, null, __jsx(HoverButton, {
    color: "primary",
    variant: "outlined",
    startIcon: __jsx(Style.PictureIcon, null),
    onClick: onReplaceButtonClick
  }, __jsx(FormattedMessage, {
    id: "image-modal.replace"
  })), onCropButtonClick && __jsx(HoverButton, {
    color: "primary",
    variant: "outlined",
    startIcon: __jsx(Style.CropIcon, null),
    onClick: onCropButtonClick
  }, __jsx(FormattedMessage, {
    id: "image-modal.crop"
  })))), __jsx(Style.Img, {
    src: imgUrl,
    "data-testid": "previewImage"
  }));
};

export default ImagePreview;